import React from 'react'
import {buildImageObj} from '../../lib/helpers'
import {imageUrlFor} from '../../lib/image-url'
import styles from './contributor.module.css'
import BlockText from '../block-text'
import {ucfirst} from '../../lib/string-utils'

const ROLES_NB = {
  developer: 'utvikler',
  designer: 'designer',
  writer: 'skribent',
  editor: 'redaktør',
  themeeditor: 'temaredaktør',
  teammember: 'del av flyt-frem teamet',
  communication: 'kommunikasjon'

}

function Contributor (props) {
  const {name, bio, roles, image, title} = props
  return (
    <div className={styles.root}>
      <div className={styles.avatar}>
        {image && image.asset && (
          <img
            src={imageUrlFor(buildImageObj(image))
              .width(400)
              .height(400)
              .fit('crop')
              .url()}
            alt=''
          />
        )}
      </div>
      <h2 className={styles.name}>{name}</h2>
      {title && <h4 className={styles.title}>{title}</h4>}
      <h4 className={styles.roles}>
        {roles.map((role, idx) => {
          const transtlatedRole = ROLES_NB[role] || role
          switch (true) {
            case idx === 0:
              return <span key={role}>{ucfirst(transtlatedRole)} </span>
            case idx === roles.length - 1:
              return <span key={role}>& {transtlatedRole} </span>
            default:
              return <span key={role}>, {transtlatedRole} </span>
          }
        })}
      </h4>
      {bio && (
        <div className={styles.bio}>
          <BlockText blocks={bio} />
        </div>
      )}
    </div>
  )
}

export default Contributor
